import * as jose from 'jose';


export class JweCredentialsEncryption {
  
  
  static async encrypt(email: string, password: string, secret: string): Promise<string> {
    try {
      const credentials = {
        email: email,
        password: password
      };

      const credentialsJson = JSON.stringify(credentials);

      let keyString = secret;
      if(keyString.length < 32) {
        keyString = keyString.padEnd(32, '0');
      } else if(keyString.length > 32) {
        keyString = keyString.substring(0, 32);
      }

      
      const encoder = new TextEncoder();
      const secretKey = encoder.encode(keyString);
      const credentialsBytes = encoder.encode(credentialsJson);

      const jwe = await new jose.CompactEncrypt(credentialsBytes)
        .setProtectedHeader({ 
          alg: 'A256GCMKW',  // AES-256 GCM Key Wrap
          enc: 'A256GCM',     // AES-256 GCM Content Encryption
          cty: 'JWT'          // Content Type: JWT
        })
        .encrypt(secretKey);
      return jwe;

    } catch (error) {
      console.error('Error encrypting credentials:', error);
      throw new Error('Credentials encryption failed');
    }
  }
}
